import { PAGINATION_MAPPINGS } from '../constants/table.constants';

export const DOSSIER_ACTIVITY_RESOURCE = {
  key: 'DOSSIER_ACTIVITY_RESOURCE',
  table: {
    defaultSort: 'name',
    dataTransform: (data) =>
      data?.map((a) => ({
        ...a
      })),
    pageMapping: PAGINATION_MAPPINGS.DEFAULT
  },
  api: {
    get: () => {
      throw new Error('replace api.get for DOSSIER_ACTIVITY_RESOURCE');
    }
  }
};
